﻿package org.zq.pixelset.model

/** 相对原图 0~1 的裁剪区域（左/上/右/下边界）。 */
data class NormalizedRect(
    val left: Float = 0f,
    val top: Float = 0f,
    val right: Float = 1f,
    val bottom: Float = 1f,
) {
    val isFullImage: Boolean
        get() = left <= 0.001f && top <= 0.001f && right >= 0.999f && bottom >= 0.999f

    fun clamped(): NormalizedRect {
        val l = left.coerceIn(0f, 1f)
        val t = top.coerceIn(0f, 1f)
        val r = right.coerceIn(l + MIN_SIZE, 1f)
        val b = bottom.coerceIn(t + MIN_SIZE, 1f)
        return copy(left = l, top = t, right = r, bottom = b)
    }

    fun toMarginCrop(): MarginCrop = MarginCrop(
        left = left,
        top = top,
        right = (1f - right).coerceAtLeast(0f),
        bottom = (1f - bottom).coerceAtLeast(0f),
    )

    companion object {
        private const val MIN_SIZE = 0.05f

        fun fromMargins(left: Float, top: Float, right: Float, bottom: Float): NormalizedRect {
            val l = left.coerceIn(0f, 0.45f)
            val t = top.coerceIn(0f, 0.45f)
            val r = (1f - right.coerceIn(0f, 0.45f)).coerceAtLeast(l + MIN_SIZE)
            val b = (1f - bottom.coerceIn(0f, 0.45f)).coerceAtLeast(t + MIN_SIZE)
            return NormalizedRect(l, t, r, b)
        }
    }
}

data class MarginCrop(
    val left: Float,
    val top: Float,
    val right: Float,
    val bottom: Float,
)
